import { Context } from 'Context/Context';
import React from 'react'
import { useContext } from 'react';
import { useState } from 'react';
import TestModal from 'Modals/TestModal';
import { toast } from 'react-toastify';
import TeamupOnCasesList from './TeamupOnCasesList';
import IconsOnListView from './IconsOnListView';
import useIsMobile from 'Hooks/useIsMobile';
import { useNavigate } from 'react-router-dom';
import CaseCard, { StatusPill } from './CaseCard';
import { openCasePage, fmtDate } from './CaseStage';
import { CardStack, CardNotice, CaseBtn, EmptyState } from './CaseListUI';
import { TEAMUP_ENABLED } from 'Constants';

function NoConflictCases({attorney, cases, setUpdateComp, reqRevCountArr, isTeamupList = false, emptyText}) {
    
    //const type = subSection !== undefined ? subSection : (showNotInterested ? "noConflict" : "noConflictInterestedCases");
        const {userDetails} = useContext(Context);
    const [closeMsg, setCloseMsg] = useState('');
    const [refreshList, setRefreshList] = useState(false);
    const isMobile = useIsMobile();
    const navigate = useNavigate();
    const usePage = !attorney;   // full case page; assistants keep the popup

    const [showEachCase, setShowEachCase] = useState(false);
    const userInfo = attorney ? attorney.userId : userDetails;

    const [singleCase, setSingleCase] = useState(null);


    const submit = (key) => {
        //navigate("/profCaseDetails/"+cases?.[key]?._id);
        setShowEachCase(true);

        setSingleCase(cases?.[key]);
    }
      const showToastMsg = () => {
        console.log("closeMsg", closeMsg);
        if(closeMsg && closeMsg !== '')
        {
            toast.info(closeMsg, {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            });
        }   
        
    }
  if (showEachCase && singleCase) {
    return (
    <TestModal
    setRefreshList={setRefreshList}
    setCloseMsg={setCloseMsg}
    onClose={() => {
        if (closeMsg) {
            toast.info(closeMsg);
        }
        setShowEachCase(false);   // close modal
        setCloseMsg('');          // reset message
        if(refreshList )
        {
            setUpdateComp(prev => !prev);
            setRefreshList(false);
        }
        }}
    attorney={attorney} reqRevCountArr={reqRevCountArr} setUpdateComp={setUpdateComp} uploadNew={showEachCase} caseData={singleCase} setSingleCase={setSingleCase} />
    )
  }
  if (!cases?.length) {
    return <EmptyState title={emptyText?.title || 'No cases yet'} body={emptyText?.body || 'Cases will appear here as they move into this stage. Try changing your filters.'} />
  }
  return (
    <CardStack>
        {cases.map((detail, key) => {
            const merged = {...detail, ...detail.caseDetails};
            const team = detail?.assistantId?.length ? detail.assistantId[0] : null;
            const pendingClose = reqRevCountArr?.[detail?.caseDetails?._id]?.reqToClose;
            return (
                <CaseCard
                    key={detail?._id || key}
                    detail={detail.caseDetails}
                    userInfo={userInfo}
                    reqRevCountArr={reqRevCountArr}
                    showNames={true}
                    onOpen={isMobile ? undefined : () => (usePage ? openCasePage(navigate, detail) : submit(key))}
                    headerPill={usePage ? (detail.caseInterest === 1 ? <StatusPill>Not interested</StatusPill> : <StatusPill tone="green">Conflict cleared{fmtDate(detail.updated_at) ? ' · ' + fmtDate(detail.updated_at) : ''}</StatusPill>) : undefined}
                    headerExtra={<span onClick={(e) => e.stopPropagation()} className="flex items-center"><IconsOnListView detail={merged} setUpdateComp={setUpdateComp}/></span>}
                    notices={pendingClose ? <CardNotice tone="danger">This case is pending closing by the client</CardNotice> : null}
                    footerNote={team ? <>Conflict cleared by team <b className="font-semibold text-navy">{team.firstName} {team.lastName}</b></> : null}
                    actions={!detail.is_deleted ? <>
                        {TEAMUP_ENABLED && userInfo && userInfo?.isActiveSubscription &&
                            <TeamupOnCasesList caseDetail={detail}
                            attorney={attorney}
                            setUpdateComp={setUpdateComp}
                            userInfo={userInfo}
                            isTeamupList={isTeamupList}
                            isCaseReqToClose={reqRevCountArr?.[detail?.caseDetails?._id]?.reqToClose  ? true : false}
                            />}
                        <CaseBtn onClick={() => (usePage ? openCasePage(navigate, detail) : submit(key))} full={isMobile} style={isMobile ? { height: '46px', fontSize: '14px' } : undefined}>{usePage ? 'Open case →' : 'Complete case details →'}</CaseBtn>
                    </> : null}
                />
            )
        })}
    </CardStack>
  )
}

export default NoConflictCases
